// Définir l'URL de base de l'API
export const ApiUrl = process.env.REACT_APP_HOST_API || "http://localhost:4000/api/v1/";

// Fonction pour générer des headers selon le type de contenu
export const header = (type = "json") => {

  const headers = {
    json: {
      "Content-Type": "application/json",
    },
    image: {
      "Content-Type": "multipart/form-data",
    },
  };

  return {
    headers: headers[type] || headers.json,
  };
};

export const imageArticleUrl = process.env.REACT_APP_ARTICLE_IMAGE || "http://localhost:4000";